import { IActionsService, IFetchActionsResponse } from 'types/actions';
import BaseService from './BaseService';

export default class ActionsService extends BaseService implements IActionsService {
  /**
   * Fetch actions, bank size, refresh time, etc.
   * @return {Promise}
   */
  fetchActions = () => {
    const config = {
      // TODO: point to /character/actions when it's implemented
      url: '/character/actions',
    };
    return this.doRequest<IFetchActionsResponse>(config);
  }
}